<template>
  <el-dialog title="订单"
             :visible.sync="computedDialogVisible"
             :show-close="closable"
             :top="top"
             :width="$isMobile ? '95%' : pcWidth"
             :modal-append-to-body="false"
             :append-to-body="true"
             :before-close="handleBeforeClose"
             :custom-class="customClass + ' orderDialog'"
             v-on="$listeners">
<!--    content插槽，里面就是对话框显示的内容 -->
    <div class="content">
      <slot name="content"></slot>
    </div>
  <!--  二维码插槽，显示支付二维码 -->
    <div class="order_code_box">
      <slot name="order_code"></slot>
    </div>
  </el-dialog>
</template>

<script>
import { MessageBox } from 'element-ui';
export default {
  name: "OrderDialog",
  props: {
    dialogVisible: Boolean,
    customClass: String,
    top: {
      type: String,
      default: '15vh'
    },
    pcWidth: {
      type: String,
      default: '30%'
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handleBeforeClose(done) {
      if(!this.closable)
        return
      MessageBox.confirm('取消创建订单？', '提示信息', {
        customClass: 'dialog-message',
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        done();
        // self.cancelWxClock();
        this.$emit('dialog-close')
      }).catch((e) => {
        console.log(e);
      });
    }
  },
  computed: {
    computedDialogVisible: {
      get() {
        return this.dialogVisible
      },
      set(val) {
        this.$emit('update:dialogVisible', val)
      }
    },
    computedDialogLoading: {
      get() {
        return this.dialogLoading
      },
      set(val) {
        this.$emit('update:dialogLoading', val)
      }
    },

  },
  created() {

  }
}
</script>

<style lang="less">
/*支付弹窗*/
.orderDialog {
  .el-dialog__header, .paymentOrderDialog .el-dialog__header {
    background-color: #2a7ddd;
    text-align: center;
  }

  .el-dialog__title, .el-dialog__headerbtn .el-dialog__close, .paymentOrderDialog .el-dialog__title, .paymentOrderDialog .el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
    font-size: 20px;
    font-weight: bold;
  }

  .el-dialog__body {
    padding: 10px;
  }

  .el-divider--horizontal {
    margin: 3px 0px;
  }
}

.dialog-message {
  /* 提示框样式修改*/

  border: none;
  width: 300px;

  .el-message-box__header {
    background-color: #3d65d0;
    text-align: center;
  }

  .el-message-box__header .el-message-box__title span {
    color: white;
    font-weight: bold;
  }

  .el-message-box__header button i {
    color: white;
  }

  .el-message-box__message p {
    font-size: 14px;
    color: #000000;
  }

  .el-message-box__btns button {
    background-color: #3d65d0;
    border-color: #3d65d0;
  }

  .el-message-box__btns button span {
    color: white;
  }
}
</style>